import React from "react";
import settings from "@content/settings.json";

const Nav = ({ onReserve }) => {
    return (
        <header
            className="fixed top-0 inset-x-0 z-50 border-b border-[var(--border)]"
            style={{
                background: "rgba(255,255,255,0.78)",
                backdropFilter: "blur(14px)",
                WebkitBackdropFilter: "blur(14px)",
            }}
            data-testid="site-nav"
        >
            <div className="container-p flex items-center justify-between h-16">
                <a href="#top" className="flex items-center gap-2" data-testid="nav-brand">
                    <span
                        className="font-mono text-lg md:text-xl font-bold tracking-tight text-slate-900"
                        style={{ letterSpacing: "-0.02em" }}
                    >
                        Grads<span className="text-brand">2</span>Pro
                        <span className="text-brand">_</span>
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-7 text-sm text-dim font-mono">
                    <a href="#why" className="hover:text-slate-900 transition-colors" data-testid="nav-why">
                        why
                    </a>
                    <a href="#trainer" className="hover:text-slate-900 transition-colors" data-testid="nav-trainer">
                        trainer
                    </a>
                    <a href="#roadmap" className="hover:text-slate-900 transition-colors" data-testid="nav-roadmap">
                        roadmap
                    </a>
                    <a href="#testimonials" className="hover:text-slate-900 transition-colors" data-testid="nav-testimonials">
                        students
                    </a>
                    <a href="#faq" className="hover:text-slate-900 transition-colors" data-testid="nav-faq">
                        faq
                    </a>
                </nav>

                <a
                    href={settings.razorpay_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary text-sm py-2.5 px-4"
                    data-testid="nav-cta"
                    onClick={onReserve}
                >
                    Reserve — ₹799
                </a>
            </div>
        </header>
    );
};

export default Nav;
